import { createFileRoute } from '@tanstack/react-router';
import { WorkflowBuilderRoute } from './-route-wrappers';
import { validateWorkflowCanvasSearch } from './-workflow-canvas-search';

/**
 * The migrated workflow-builder URL. No `appBundle`: this URL has no `journeys` segment, and
 * the resolver's bundle-aware branch rebuilds the target from the bundle prefix — which would
 * find no `/journeys/` here and land on the Journeys home instead. The resolver itself runs
 * inside the flag branch, in `WorkflowBuilderRoute`.
 */
function AutomationWorkflowRoute() {
  const { campaignId } = Route.useParams();

  return <WorkflowBuilderRoute campaignId={campaignId} />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/automations/$campaignId/workflow')({
  component: AutomationWorkflowRoute,
  validateSearch: validateWorkflowCanvasSearch,
});
